export enum EActivityType {
    default = 'Default',
    invite = 'Invite',
    inviteReview = 'InviteReview',
    complete = 'Complete',
    completeSuccess = 'CompleteSuccess',
    feedback = 'Feedback',
    feedbackSuccess = 'FeedbackSuccess'
}

export enum EActivityTriggerType {
    head = 'HEAD',
    banner = 'BANNER',
    sidebar = 'SIDEBAR',
    search = 'SEARCH',
    search_result = 'SEARCH_RESULT',
    search_result_top = 'SEARCH_RESULT_TOP',
    search_result_list = 'SEARCH_RESULT_LIST',
    search_summary = 'SEARCH_SUMMARY',
    search_pum = 'SEARCH_PUM',
    search_design = 'SEARCH_DESIGN',
    pdf_view = 'PDF_DOWNLOAD',
    technology = 'CREATE_TECHNOLOGY_ROADMAP',
    idea = 'IDEA',
    project = 'CREATE_PROJECT',
    monitor = 'CREATE_MONITOR',
    newsletter = 'NEWSLETTER',
    read_more_company = 'READ_MORE_COMPANY',
    export = 'EXPORT',
    copilot = 'COPILOT',
    analysis = 'ANALYSIS',
    patent_view = 'PATENT_VIEW',
    paper_view = 'PAPER_VIEW',
    history = 'HISTORY',
    disclosure = 'DISCLOSURE',
    more_disclosure = 'MORE_DISCLOSURE',
    rewrite_disclosure = 'REWRITE_DISCLOSURE',
    onboarding = 'ONBOARDING'
}

export enum EActivityStatus {
    unfinished = 'UNFINISHED',
    unreceived = 'UNRECEIVED',
    received = 'RECEIVED'
}

export enum E_LanguageLong {
    en = 'en_US',
    cn = 'zh_CN',
    tw = 'zh_TW',
    jp = 'ja_JP'
}

export enum ErrorCodes {
    SMS_ERROR = 90112022,
    // 验证码错误
    SMS_CODE_ERROR = 9030119,
    // 账号已存在
    SMS_MOBILE_EXITED = 9030129,
    // 重复领取
    REWARD_RECEIVED = 90112023
}

export interface IPostMobileVerifyCodeParams {
    purpose: string
    country_code: string
    mobile_number: number|string
    language: string
}

export interface IProfileInfo {
    need_company?: boolean,
    company: string,
    need_mobile?: boolean,
    mobile?: string,
    code?: string,
    trigger_manually?:boolean,
    country_code?: string,
}
